import axios, { AxiosResponse } from "axios";
import AuthTokenHelper from "helpers/AuthTokenHelper";

import { baseConfig } from "config";
import { logOutUserIfTokenInvalid } from "./token";

const api = axios.create({
	baseURL: baseConfig.baseURL,
	xsrfCookieName: "csrftoken",
	xsrfHeaderName: "X-CSRFToken",
	paramsSerializer: {
		indexes: null
	}
});

api.interceptors.request.use(
	(config: any) => {
		const newConfig = {
			...config,
			headers: {
				...config.headers
			}
		};
		const token = AuthTokenHelper.getAuthToken();
		if (token) {
			newConfig.headers.Authorization = `Bearer ${token}`;
		}
		const tenantString = localStorage.getItem("tenant");
		if (tenantString) {
			const tenant = JSON.parse(tenantString);
			newConfig.headers["Tenant-Id"] = tenant.value;
		}

		return newConfig;
	},
	(error: any) => Promise.reject(error)
);

api.interceptors.response.use(
	(response) => response,
	(error) => logOutUserIfTokenInvalid(error)
);

const get = async (url: string, config?: any) => {
	const response: AxiosResponse = await api.get(url, {
		...config
	});
	return response.data;
};

const patch = async (url: string, data: any, config?: any) => {
	const response: AxiosResponse = await api.patch(url, data, {
		...config
	});
	return response.data;
};

const post = async (url: string, data: any, config?: any) => {
	const response: AxiosResponse = await api.post(url, data, {
		...config
	});
	return response.data;
};

const put = async (url: string, data: any, config?: any) => {
	const response: AxiosResponse = await api.put(url, data, {
		...config
	});
	return response.data;
};

const remove = async (url: string, config?: any) => {
	const response: AxiosResponse = await api.delete(url, {
		...config
	});
	return response.data;
};

export { get, patch, post, put, remove };
